"use client"

import React from 'react'
import { useRouter } from 'next/navigation';

function ArticleBox({ date, title, description, image, link }) {
    const navigate = useRouter();

    return (
        <div className="w-full lg:w-[376px]  p-4  m-auto lg:m-0 bg-white shadow-lg rounded-3xl flex flex-col space-y-2 items-center text-center">
            <img src={image} className="w-[100%] aspect-square" />
            <div className='flex flex-row'><img src={"/images/calenderIcon.svg"} className='' /><p className='mt-[10px] font-lato'>{date}</p>
            </div>
            <p className="font-lato text-[16px] lg:text-[24px] text-[#49378F] font-bold mb-2 lg:w-[80%] cursor-pointer" onClick={()=>{ navigate.push(`${link}`) }}>{title}</p>
            <p className="text-[14px] lg:text-[18px] font-lato lg:w-[80%]">{description}...</p>
        </div>
    )
}

export default ArticleBox